// @flow
import { createReducer } from 'redux-act';

import type { Filter, Filters as State } from '../../types';
import { change, reset } from '../actions/filters';

export const initialState: State = {
  sales: 'show',
  premiums: 'show',
  semantic: 'semantic',
  unavailable: 'hide',
  tlds: 'suggested',
  phases: 'golive,landrush,sunrise',
};

function changeHandler(
  state: State,
  payload: { name: Filter, value: string, ... },
):
  | any
  | State
  | { [Filter]: string, phases: string, ... }
  | { [Filter]: string, tlds: string, ... } {
  if (payload.value === state[payload.name]) {
    return state;
  }

  if (payload.name !== 'tlds') {
    return {
      ...state,
      [payload.name]: payload.value,
    };
  }

  let newValue = `${payload.value}` || 'suggested';
  const splitted = newValue.split(',');
  newValue =
    splitted[0] === 'suggested' && splitted.length > 1
      ? newValue.replace('suggested,', '')
      : splitted.indexOf('suggested') > -1 && splitted.length > 1
        ? 'suggested'
        : newValue;

  return {
    ...state,
    tlds: newValue,
  };
}

function resetHandler() {
  return initialState;
}

export default (createReducer(
  {
    [change.toString()]: changeHandler,
    [reset.toString()]: resetHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
